import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../styles/uniqueClass.css";
import {
  SettingGroupdropdown,
  SettingsChild,
  UpdateCommonSettings,
} from "services/apiService";
import { Box, Button, TextField } from "@mui/material";
import toast from "react-hot-toast";
import selectProducts from "../../assect/Images/SelectImage.jpg";
import NoDataFound from "../../assect/Images/9264885-removebg.png";
import Toggle from "common/Toggle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  faCircleExclamation,
  faFileArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import ImageUploaderModal from "common/ImageUploaderModal";
const Dashboard = () => {
  const [activeCard, setActiveCard] = useState<number | null>(1);
  const [sidebar, setSidebar] = useState<any[]>([]);
  console.log(sidebar);
  const [renderContent, setRenderContent] = useState<any[]>([]);
  console.log(renderContent);
  const [errors, setErrors] = useState<any>({});
  const [editableRows, setEditableRows] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [ischangingImageId, setischangingImageId] = useState<number | null>(
    null
  );
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const baseUrl = process.env.REACT_APP_IMAGE_URL || "";
  useEffect(() => {
    fetchSideBar();
  }, []);
  useEffect(() => {
    if (activeCard !== null) {
      fetchRenderContent(activeCard);
    }
  }, [activeCard]);
  const fetchSideBar = async () => {
    try {
      const response = await SettingGroupdropdown();
      if (response.status_code === 200) {
        setSidebar(response?.data);
      }
    } catch (error) {
      console.error("Error fetching sidebar", error);
    }
  };
  const fetchRenderContent = async (id: number) => {
    try {
      const response = await SettingsChild(id);
      if (response.status_code === 200) {
        setRenderContent(response?.data);
      } else {
        setRenderContent([]);
      }
    } catch (error) {
      console.error("Error fetching render content", error);
    }
  };
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    id: number
  ) => {
    const { name, value } = e.target;
    setRenderContent((prevData) =>
      prevData?.map((item: any) =>
        item.id === id ? { ...item, [name]: value } : item
      )
    );
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: {
        ...prevErrors[id],
        key_value: value ? "" : "This field is required",
      },
    }));
  };
  const handleToggleChange = (id: number, checked: number) => {
    if (editableRows[id]) {
      setRenderContent((prevData) =>
        prevData?.map((item: any) =>
          item.id === id ? { ...item, is_active: checked ? 1 : 0 } : item
        )
      );
    }
  };
  const handleEditRow = (id: number) => {
    setEditableRows({ ...editableRows, [id]: true });
    setErrors((prevErrors) => ({ ...prevErrors, [id]: {} }));
  };
  const handleSaveRow = (id: number) => {
    const editedItem = renderContent?.find((item: any) => item.id === id);
    if (!editedItem?.key_value || editedItem.key_value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: { key_value: "This field is required" },
      }));
      return;
    }
    handleSubmit(id);
    setEditableRows({ ...editableRows, [id]: false });
  };
  const handleCancelEditRow = (id: number) => {
    setEditableRows({ ...editableRows, [id]: false });
    setErrors((prevErrors) => ({ ...prevErrors, [id]: {} }));
    setischangingImageId(null);
  };
  const handleSubmit = async (id: number) => {
    const editedItem = renderContent?.find((item: any) => item.id === id);
    if (!editedItem) {
      toast.error("Invalid Item Selected");
      return;
    }
    const payload = {
      id: editedItem.id,
      key_name: editedItem.key_name,
      key_value: editedItem.key_value,
      is_active: editedItem.is_active,
    };
    try {
      const response = await UpdateCommonSettings(payload);
      if (response?.status_code === 200) {
        toast.success("Settings Updated Successfully");
      } else {
        toast.error("Settings Update Failed");
      }
    } catch (error) {
      toast.error("Settings Update Failed");
    }
  };

  const handleOpenModal = (id) => {
    setischangingImageId(id);
    setModalOpen(true);
  };
  const handleCloseModal = () => setModalOpen(false);
  const handleImageSelected = (image: string) => {
    const finalImage = image[0];
    const name = "key_value";
    setRenderContent((prevData) =>
      prevData?.map((item: any) =>
        item.id === ischangingImageId ? { ...item, [name]: finalImage } : item
      )
    );
    setModalOpen(false);
  };
  const renderDynamicForm = () => {
    if (activeCard === null) {
      return (
        <div className="main-content-placeholder-xyz">
          <img src={selectProducts} width={400} alt="select_items" />
          Please select a sidebar category to load settings.
        </div>
      );
    }
    if (renderContent === null) {
      return (
        <div className="main-content-placeholder-xyz">
          <img src={NoDataFound} alt="no_data" width={400} />
          No data available for the selected category.
          <a
            href="/setting-single-create"
            style={{ color: "blue", textDecoration: "none" }}
          >
            Click to create
          </a>
        </div>
      );
    }
    return (
      <>
        <div className="">
          {renderContent?.map((item: any) => (
            <Box
              key={item.id}
              className={`settings-row-xyz ${
                editableRows[item.id] ? "editing" : ""
              }`}
              onMouseEnter={(e) => e.currentTarget.classList.add("hovered")}
              onMouseLeave={(e) => e.currentTarget.classList.remove("hovered")}
            >
              <div>
                {["unknown", "TEXT_INPUT"].includes(item.validation_name) && (
                  <TextField
                    variant="outlined"
                    label={item.key_name.replace(/_/g, " ")}
                    name="key_value"
                    value={item.key_value}
                    onChange={(e) => handleInputChange(e, item.id)}
                    fullWidth
                    InputProps={{ readOnly: !editableRows[item.id] }}
                    error={!!errors[item.id]?.key_value}
                    helperText={errors[item.id]?.key_value}
                  />
                )}
                {["NUMBER_INPUT"].includes(item.validation_name) && (
                  <TextField
                    variant="outlined"
                    label={item.key_name.replace(/[\d\W]+/g, " ")}
                    name="key_value"
                    type="text"
                    value={item.key_value}
                    onChange={(e) => {
                      const regex = /^[\d\W]*$/;
                      if (regex.test(e.target.value)) {
                        handleInputChange(e, item.id);
                      }
                    }}
                    fullWidth
                    InputProps={{ readOnly: !editableRows[item.id] }}
                    error={!!errors[item.id]?.key_value}
                    helperText={errors[item.id]?.key_value}
                  />
                )}
                {["PAN_NUMBER"].includes(item.validation_name) && (
                  <TextField
                    variant="outlined"
                    label={item.key_name.replace(/_/g, " ")}
                    name="key_value"
                    type="number"
                    value={item.key_value}
                    onChange={(e) => handleInputChange(e, item.id)}
                    fullWidth
                    InputProps={{ readOnly: !editableRows[item.id] }}
                    error={!!errors[item.id]?.key_value}
                    helperText={errors[item.id]?.key_value}
                  />
                )}
                {item.validation_name === "TEXT_AREA" && (
                  <div style={{ maxWidth: "500px", overflow: "auto" }}>
                    <TextField
                      variant="outlined"
                      label={item.key_name.replace(/_/g, " ")}
                      name="key_value"
                      multiline
                      value={item.key_value}
                      onChange={(e) => handleInputChange(e, item.id)}
                      fullWidth
                      InputProps={{ readOnly: !editableRows[item.id] }}
                      error={!!errors[item.id]?.key_value}
                      helperText={errors[item.id]?.key_value}
                    />
                  </div>
                )}
                {item.validation_name === "CK_EDITOR" && (
                  <div style={{ overflow: "auto" }}>
                    <CKEditor
                      editor={ClassicEditor}
                      data={item.key_value}
                      disabled={!editableRows[item.id]}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        handleInputChange(
                          { target: { name: "key_value", value: data } } as any,
                          item.id
                        );
                      }}
                    />
                  </div>
                )}
                {item.validation_name === "IMAGE" && (
                  <div
                    style={{
                      width: "100%",
                      padding: "20px",
                      borderRadius: "10px",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#fff",
                    }}
                  >
                    <div style={{ color: "grey", marginBottom: "5px" }}>
                      {item.key_name.replace(/_/g, " ")}
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        marginBottom: "20px",
                        border: "1px dashed #ccc",
                        padding: "20px",
                        display: "flex",
                        justifyContent: "center",
                        borderRadius: "10px",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      {item.key_value ? (
                        <>
                          <img
                            src={`${baseUrl}${item.key_value}`}
                            alt="Selected"
                            style={{
                              width: "300px",
                              transition: "transform 0.2s",
                              cursor: "pointer",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.transform = "scale(1.05)";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                          />
                        </>
                      ) : (
                        <p style={{ color: "orange" }}>
                          <FontAwesomeIcon icon={faCircleExclamation} />
                          &nbsp; &nbsp; No image selected. Please upload an
                          image.
                        </p>
                      )}
                    </div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        onClick={() => handleOpenModal(item.id)}
                        variant="contained"
                        color="primary"
                      >
                        <FontAwesomeIcon icon={faFileArrowUp} /> &nbsp; &nbsp;
                        Upload Image
                      </Button>
                    </div>
                  </div>
                )}
                {item.validation_name === "EMAIL" && (
                  <TextField
                    variant="outlined"
                    label={item.key_name.replace(/_/g, " ")}
                    name="key_value"
                    type="email"
                    value={item.key_value}
                    onChange={(e) => handleInputChange(e, item.id)}
                    fullWidth
                    InputProps={{ readOnly: !editableRows[item.id] }}
                    error={!!errors[item.id]?.key_value}
                    helperText={errors[item.id]?.key_value}
                  />
                )}
                {item.validation_name === "GST_NUMBER" && (
                  <TextField
                    variant="outlined"
                    label={item.key_name.replace(/_/g, " ")}
                    name="key_value"
                    type="text"
                    value={item.key_value}
                    onChange={(e) => handleInputChange(e, item.id)}
                    fullWidth
                    InputProps={{ readOnly: !editableRows[item.id] }}
                    error={!!errors[item.id]?.key_value}
                    helperText={errors[item.id]?.key_value}
                  />
                )}
              </div>
              <div className="d-flex gap-3 mt-2">
                <Toggle
                  checked={item.is_active === 1}
                  onChange={(newValue) => handleToggleChange(item.id, newValue)}
                />
                {!editableRows[item.id] ? (
                  <Button
                    variant="contained"
                    color="primary"
                    className="edit-btn"
                    onClick={() => handleEditRow(item.id)}
                  >
                    click to Edit
                  </Button>
                ) : (
                  <Box>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleSaveRow(item.id)}
                    >
                      Save
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => handleCancelEditRow(item.id)}
                    >
                      Cancel
                    </Button>
                  </Box>
                )}
              </div>
            </Box>
          ))}
        </div>
      </>
    );
  };
  return (
    <>
      <div className="dashboard-container-xyz">
        <div className="sidebar-xyz">
          <div className="sidebar-content-xyz">
            {sidebar?.map((item) => (
              <>
                <div
                  key={item?.id}
                  className={`sidebar-item-xyz ${
                    activeCard === item.id ? "active-sidebar-item-xyz" : ""
                  }`}
                  onClick={() => setActiveCard(item.id)}
                >
                  <h6>
                    <span style={{ marginRight: "8px", color: "black" }}>
                      •
                    </span>
                    {item?.name}
                  </h6>
                </div>
              </>
            ))}
          </div>
        </div>
        <div className="main-content-xyz">{renderDynamicForm()}</div>
      </div>
      <ImageUploaderModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onImageSelect={handleImageSelected}
        allowMultiple={false}
      />
    </>
  );
};
export default Dashboard;
